import moment from "moment";
import { LockOutlined } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import SidebarIndex from "../../SidebarIndexNew";
import { toggleModal } from "../../../../../reducers/modalReducer";
import { setDataroomConfig } from "../../../../../reducers/dataRoomReducer";
import socket, { getRequest, postRequest, putRequest, deleteRequest, showMessage } from '../../../../../config';
import HeadingSubheadingContent from "../../../../../components/HeadingSubheadingContent";
import { setDeduperFiles, setUnallocatedFiles } from "../../../../../reducers/filesReducer";
import { setLogList, setRModalData, setOpenRModal, setTargetSection, updateFileAllocation } from "../../../../../reducers/filesAllocationReducer";
import debounce from "lodash.debounce";
import "../../../../../../styles/rsuite.change.css";
import 'react-circular-progressbar/dist/styles.css';
import { findAndUpdateReSyncing, findAndUpdateSyncing, resetReSyncing, resetSyncing, startReSyncing, startSyncing, startSyncingFolders, syncingFoldersComplete } from "../../../../../reducers/fileManagementReducer";
import { useNavigate } from "react-router-dom";
import { INSURANCE_REPORT_LOADING_STORAGE_KEY, AI_REPORT_DISCLAIMER_KEY, getPersistedReportLoadingMap, getAiReportDisclaimerAgreements, writeJsonToStorage } from "./components/storageUtils";
import ModalsSection from "./components/ModalsSection";
import SectionRenderer from "./components/SectionRenderer";
import HeaderActions from "./components/HeaderActions";
import DataRoomButtons from "./components/DataRoomButtons";
import { useModuleData } from "./useModuleData";
import { isCustomTempSectionNo } from "../customSectionAccess";


export default function QuestionAnswersPage({ isManualAdd, getCompany, setIsWorkflowReport, profileClass, advisors, permissionLevel, tab, setTab, sanitiseTab, company, setCompany, companyId, openKPI, toggleReport, enableAIEnhancedReporting, calculateStats, calculateSubFolderStats, getCompletenessAndRiskHTML, aiEnhanced, setAiEnchaned, reloadModule, twoMinuteTestAIReport, getFitInvestorFirms, isTwoMinuteTesHomePage, setOpenTabs, openTabs, companyIndex, setCompanyDashboardTab, setCloneImportResult, setCurrentScore, reportHistories, setReportHistories, setFileReport, sortSections, showAlert, handleSuperflowNext, setTabName, closeTab, isBackFitReport, setIsBackFitReport, isLoader, setIsLoader, syncApiBase = '/modules', logsApiBase = '/modules' }) {

    let dispatch = useDispatch();
    const navigate = useNavigate();
    const spinner = document.getElementById("e1jygW4piZH1");
    let user = useSelector(state => state.user);
    let modal = useSelector(state => state.modal);
    let { syncing } = useSelector((state) => state.appData);
    let { logList, targetSection, processing, company: fileAllocationCompany, tempModuleAllocationPatch } = useSelector(state => state.fileAllocation);

    let { unallocatedFiles, deduperReports: dupCheck } = useSelector(state => state.files);
    const companyObjectId = company?._id;
    const reportGenerationRequestRef = useRef(null);
    const lastReportAnchorRef = useRef(null); // Stores anchor to scroll when closing report
    const isComponentMountedRef = useRef(false);
    // Helper function to generate unique key for section/question
    const getReportGenerationKey = (data, isQuestion) => {
        if (isQuestion) {
            // For questions: use sectionId + questionId or qNo
            const sectionId = data?.sectionId || data?.section?._id;
            const questionId = data?._id || data?.qNo;
            return `question-${sectionId}-${questionId}`;
        } else {
            // For sections: use sectionId
            const sectionId = data?._id || data?.section?._id;
            return `section-${sectionId}`;
        }
    };

    const [reportGenerateLoading, setReportGenerateLoadingState] = useState(() => {
        if (!companyObjectId) return null;
        const loadingMap = getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];
        if (entry && entry.status === 'pending') {
            reportGenerationRequestRef.current = entry.requestId || null;
            return entry.generatingKey || null;
        }
        return null;
    });
    const [agreedAiReportDisclaimerIds, setAgreedAiReportDisclaimerIds] = useState(() => getAiReportDisclaimerAgreements());
    const hasAgreedAiReportDisclaimer = companyObjectId ? agreedAiReportDisclaimerIds.includes(companyObjectId) : false;
    let [section, setSection] = useState();
    let [refresh, setRefresh] = useState(false);
    let [loading, setLoading] = useState(false);
    let [logModule, setLogModule] = useState([]);
    let [deleteFile, setDeleteFile] = useState();
    let [isSaving, setIsSaving] = useState(false);
    let [saveTimeout, setSaveTimeout] = useState();
    let [attachment, setAttachment] = useState([]);
    let [visibleSection, setVisibleSection] = useState(null);
    let [isFAMenuVisible, setFAMenuVisible] = useState(false);
    let [newUpgradeSync, setNewUpgradeSync] = useState(false);
    let [deleteFileLoading, setDeleteFileLoading] = useState(false);
    let [deleteFileQuestionId, setDeleteFileQuestionId] = useState();
    let [deleteUnallocatedFile, setDeleteUnallocatedFile] = useState();
    let [questionsAndAnswersToSave, setQuestionsAndAnswersToSave] = useState([]);
    const [dateValue, setDateValue] = useState({});
    const location = useLocation();
    const [dataRoomMenuVisible, setDataRoomMenuVisible] = useState(false);
    // State to track which section to navigate to after disclaimer
    const [sectionToNavigate, setSectionToNavigate] = useState(null);
    // Ref to track section navigation to avoid stale closures in callbacks
    const sectionToNavigateRef = useRef(null);
    // Store the expected reportType after generation to find it after refetch
    const expectedReportTypeRef = useRef(null);

    // ── Temp-module: always fetch from API by slug (tab) ────────────────────
    const {
        module: activeModule,
        loading: activeModuleLoading,
        refetch: refetchActiveModule,
    } = useModuleData(companyId, tab, company);

    // True for both the old static "repository" tab and any temp-module whose type contains "repository"
    const isDataRepository = tab === 'repository' || (syncApiBase === '/modules' && activeModule?.type && /repository/i.test(String(activeModule.type)));

    // Local copy of the module — updated in-place after save/delete/move without re-fetching
    const [localModule, setLocalModule] = useState(null);

    useEffect(() => {
        if (activeModule) {
            setLocalModule(JSON.parse(JSON.stringify(activeModule)));
        }
    }, [activeModule]);

    // Recompute section and module completion stats from local question answer data
    const recomputeLocalStats = (mod) => {
        if (!mod?.sections) return mod;
        let totalQ = 0, completedQ = 0;
        for (const sec of mod.sections) {
            if (!sec.questions) continue;
            const secTotal = sec.questions.length;
            const secCompleted = sec.questions.filter(q => q.answer?.status === 'Completed' || q.answer?.status === 'Not Applicable').length;
            const secPercent = secTotal > 0 ? Math.round((secCompleted / secTotal) * 100) : 0;
            sec.stats = { ...sec.stats, completionPercent: secPercent, completed: secCompleted, total: secTotal };
            totalQ += secTotal;
            completedQ += secCompleted;
        }
        const modPercent = totalQ > 0 ? Math.round((completedQ / totalQ) * 100) : 0;
        mod.stats = { ...mod.stats, completionPercent: modPercent, completed: completedQ, total: totalQ };
        return mod;
    };

    // Patch localModule answers from the savedQuestions returned by the save API
    const updateLocalAnswers = useCallback((savedQuestions) => {
        if (!savedQuestions?.length) return;
        setLocalModule(prev => {
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const savedQ of savedQuestions) {
                for (const sec of clone.sections) {
                    const qi = sec.questions?.findIndex(q =>
                        q._id === savedQ._id || q._id?.toString() === savedQ._id?.toString()
                    );
                    if (qi >= 0) {
                        sec.questions[qi] = { ...sec.questions[qi], answer: savedQ.answer };
                        // Also patch the same question inside any subFolder that holds a copy
                        if (sec.subFolders) {
                            Object.values(sec.subFolders).forEach(sub => {
                                const sqi = sub.questions?.findIndex(q =>
                                    q._id === savedQ._id || q._id?.toString() === savedQ._id?.toString()
                                );
                                if (sqi >= 0) sub.questions[sqi] = { ...sub.questions[sqi], answer: savedQ.answer };
                            });
                        }
                        break;
                    }
                }
            }
            return recomputeLocalStats(clone);
        });
    }, []);

    // Patch a single answer in localModule after /question/addNote (workflow notes) — no full refetch
    const patchAnswerInModule = useCallback((questionId, updatedAnswer) => {
        setLocalModule(prev => {
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const sec of clone.sections) {
                const qi = sec.questions?.findIndex(q =>
                    q._id === questionId || q._id?.toString() === questionId?.toString()
                );
                if (qi >= 0) {
                    sec.questions[qi] = { ...sec.questions[qi], answer: updatedAnswer };
                    break;
                }
            }
            return clone;
        });
    }, []);

    // After /modules/allocateFiles, merge returned TempAnswer payloads into localModule (no refetch)
    useEffect(() => {
        const patch = tempModuleAllocationPatch;
        if (!patch?.savedQuestions?.length || !localModule || !activeModule?._id) return;
        if (String(patch.moduleId) !== String(activeModule._id)) return;
        updateLocalAnswers(patch.savedQuestions);
        dispatch(updateFileAllocation({ tempModuleAllocationPatch: null }));
    }, [tempModuleAllocationPatch, localModule, activeModule?._id, updateLocalAnswers, dispatch]);

    // Sync additionalSections (user-defined sections) whenever the module loads
    useEffect(() => {
        if (!activeModule) return;
        const customSections = (activeModule.sections || []).filter(
            s => s.companyId && s.type === 'Additional Sections'
        );
        const saved = customSections.map(s => [s._id, s.sectionName, true, true]);
        const empty = Array.from({ length: Math.max(0, 5 - saved.length) }, () => [null, '', false, true]);
        setAdditionalSections([...saved, ...empty]);
    }, [activeModule?._id]); // eslint-disable-line react-hooks/exhaustive-deps

    // Reload module data after AutoFill completes (triggered via modal flag)
    useEffect(() => {
        if (!modal.autoFillJustCompleted) return;
        dispatch(toggleModal({ autoFillJustCompleted: false }));
        refetchActiveModule();
    }, [modal.autoFillJustCompleted]); // eslint-disable-line react-hooks/exhaustive-deps
    // ── End temp-module fetch ────────────────────────────────────────────────

    // Helper function to sanitize section name for URLs (matches backend logic)
    const sanitizeSectionName = (name) => {
        if (!name) return '';
        return name.toLowerCase()
            .replace(/\s+/g, '-')  // Replace spaces with hyphens
            .replace(/[^a-z0-9-]/g, '')  // Remove special characters
            .replace(/-+/g, '-')  // Replace multiple hyphens with single hyphen
            .replace(/^-|-$/g, '');  // Remove leading/trailing hyphens
    };

    // Helper function to get section tab name
    const getSectionTabName = (section, isQuestion, data) => {
        if (!section) return '';
        const sectionName = section.sectionName || section.name || '';
        const sanitized = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        return sanitized ? `${sanitized}-section-report` : '';
    };

    // Helper function to check if a section report exists for a given section
    const hasSectionReport = (section, isQuestion, data) => {
        if (!section || !company?.['aiReports']) return false;
        const sectionName = section.sectionName || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sanitizeSectionName(sectionName);
        if (!sanitizedSectionName) return false;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].some(report =>
            report.reportType === reportType && report?.htmlReport
        );
    };

    // Helper function to get the report data for a section/question
    const getSectionReport = (section, isQuestion, data) => {
        if (!section || !company?.['aiReports']) return null;
        const sectionName = section.no || section.name || '';
        const sanitizedSectionName = isQuestion ? data.qNo : sectionName;
        if (!sanitizedSectionName) return null;
        const reportType = `sectionReport_${sanitizedSectionName}`;
        return company['aiReports'].find(report =>
            report.reportType === reportType && report?.htmlReport
        ) || null;
    };
    const debouncedSaveAnswer = useCallback(
        debounce((e, question, qNo) => {
            saveAnswer(e, question, qNo);
        }, 3000),
        [] // ← ensures debounce function is created once
    );

    useEffect(() => {
        socket.on('SyncingStart', (data) => {
            dispatch(startSyncing(data))
        })

        socket.on('SyncingFoldersStart', () => {
            dispatch(startSyncingFolders())
        })

        socket.on('SyncingFoldersComplete', () => {
            dispatch(syncingFoldersComplete())
        })

        socket.on('Syncing', (data) => {
            dispatch(findAndUpdateSyncing(data))
        })

        socket.on('SyncingFilesNotAvailable', (data) => {
            showMessage(`There are currently no files to sync.`)
        })

        socket.on('SyncingComplete', (data) => {
            dispatch(resetSyncing())
            showMessage(`Syncing Process completed.`)
        })

        socket.on('syncingComplete', () => {
            dispatch(resetSyncing())
        })

        socket.on('ReSyncingStart', (data) => {
            dispatch(startReSyncing(data))
        })


        socket.on('ReSyncing', (data) => {
            dispatch(findAndUpdateReSyncing(data))
        })

        socket.on('ReSyncingComplete', () => {
            dispatch(resetReSyncing())
        })
    }, [])

    useEffect(() => {
        isComponentMountedRef.current = true;
        return () => {
            isComponentMountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (!companyObjectId) {
            reportGenerationRequestRef.current = null;
            if (isComponentMountedRef.current) {
                setReportGenerateLoadingState(null);
            }
            return;
        }
        const loadingMap = getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];
        reportGenerationRequestRef.current = entry?.requestId || null;
        const generatingKey = entry?.status === 'pending' ? (entry.generatingKey || null) : null;
        if (isComponentMountedRef.current) {
            setReportGenerateLoadingState(prev => {
                // Only update if the value actually changed
                if (prev !== generatingKey) {
                    return generatingKey;
                }
                return prev;
            });
        }
    }, [companyObjectId]);

    // Add storage event listener to sync state when localStorage changes (e.g., from other tabs)
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === INSURANCE_REPORT_LOADING_STORAGE_KEY && companyObjectId) {
                const loadingMap = getPersistedReportLoadingMap();
                const entry = loadingMap[companyObjectId];
                const generatingKey = entry?.status === 'pending' ? (entry.generatingKey || null) : null;
                if (isComponentMountedRef.current) {
                    setReportGenerateLoadingState(generatingKey);
                    reportGenerationRequestRef.current = entry?.requestId || null;
                }
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, [companyObjectId]);

    const startReportGenerationLoading = useCallback((generatingKey) => {
        const requestId = `${companyObjectId || 'company'}-${Date.now()}`;
        const loadingMap = getPersistedReportLoadingMap();
        if (companyObjectId) {
            loadingMap[companyObjectId] = {
                status: 'pending',
                requestId,
                generatingKey: generatingKey || null,
                startedAt: Date.now()
            };
            writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
        }
        reportGenerationRequestRef.current = requestId;
        if (isComponentMountedRef.current) {
            setReportGenerateLoadingState(generatingKey || null);
        }
        return requestId;
    }, [companyObjectId]);

    const stopReportGenerationLoading = useCallback((requestId, options = {}) => {
        const { force = false } = options;
        const effectiveRequestId = requestId || reportGenerationRequestRef.current;

        const clearComponentState = (matchedRequestId) => {
            if (!matchedRequestId || reportGenerationRequestRef.current === matchedRequestId) {
                reportGenerationRequestRef.current = null;
            }
            if (isComponentMountedRef.current) {
                // Force state update to null
                setReportGenerateLoadingState(null);
            }
        };

        if (!companyObjectId) {
            clearComponentState(effectiveRequestId);
            return;
        }

        const loadingMap = getPersistedReportLoadingMap();
        const entry = loadingMap[companyObjectId];

        if (!entry) {
            // No entry in localStorage, ensure state is cleared
            clearComponentState(effectiveRequestId);
            return;
        }

        const isMatchingRequest = !effectiveRequestId || entry.requestId === effectiveRequestId;
        const entryAgeMs = entry?.startedAt ? Date.now() - entry.startedAt : 0;
        const isStale = entryAgeMs > 5 * 60 * 1000; // 5 minutes fallback

        if (force || isMatchingRequest || isStale) {
            // Clear from localStorage first
            delete loadingMap[companyObjectId];
            writeJsonToStorage(INSURANCE_REPORT_LOADING_STORAGE_KEY, loadingMap);
            // Then clear component state
            clearComponentState(entry.requestId);
            // Double-check: verify localStorage was cleared and sync state
            setTimeout(() => {
                if (isComponentMountedRef.current) {
                    const verifyMap = getPersistedReportLoadingMap();
                    const verifyEntry = verifyMap[companyObjectId];
                    if (!verifyEntry || verifyEntry.status !== 'pending') {
                        setReportGenerateLoadingState(null);
                    }
                }
            }, 100);
            return;
        }
    }, [companyObjectId]);

    const handleAiReportDisclaimerClose = useCallback(async () => {
        dispatch(toggleModal({ open: '' }));
        if (!companyObjectId) return;

        // Save agreement to localStorage first
        const updatedAgreements = [...agreedAiReportDisclaimerIds];
        if (!updatedAgreements.includes(companyObjectId)) {
            updatedAgreements.push(companyObjectId);
            writeJsonToStorage(AI_REPORT_DISCLAIMER_KEY, updatedAgreements);
            setAgreedAiReportDisclaimerIds(updatedAgreements);
        }
        await getCompany('repository', company);
        let sectionTab = null;
        const expectedReportType = expectedReportTypeRef.current;
        let anchorToStore = lastReportAnchorRef.current;

        if (expectedReportType) {
            const sanitizedSectionName = expectedReportType.replace('sectionReport_', '');
            sectionTab = `${sanitizedSectionName}-section-report`;
        }

        // Fallback: Use navigation target to construct tab name (from R button flow)
        if (!sectionTab) {
            const navigationTarget = sectionToNavigateRef.current;
            if (navigationTarget) {
                const { section, isQuestion, data } = navigationTarget;
                sectionTab = getSectionTabName(section, isQuestion, data);
                if (!anchorToStore) {
                    anchorToStore = section?.sectionNo || section?.no || data?.sectionNo || data?.qNo || null;
                }
            }
        }

        // Navigate to the tab (following the same pattern as R button)
        if (sectionTab) {
            // Add tab to openTabs set so it appears in the UI
            if (setOpenTabs && openTabs) {
                const newOpenTabs = new Set(openTabs);
                newOpenTabs.add(sectionTab);
                setOpenTabs(newOpenTabs);
            }

            // Persist anchor for scrolling back on close
            if (anchorToStore) {
                lastReportAnchorRef.current = anchorToStore;
                try {
                    localStorage.setItem('lastReportAnchor', anchorToStore);
                } catch (_) { /* ignore */ }
            }

            // Set tab and update URL hash (using proper routing like R button does)
            await setTab(sectionTab);
            // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
            // Use history.replaceState to ensure the hash persists without triggering navigation
            setTimeout(() => {
                const hashValue = `#${sectionTab}`;
                if (window.location.hash !== hashValue) {
                    window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
                }
            }, 100);

            // Clear refs after successful navigation
            expectedReportTypeRef.current = null;
            setSectionToNavigate(null);
            sectionToNavigateRef.current = null;
        }
    }, [companyObjectId, dispatch, setTab, getSectionTabName, company, navigate, getCompany, agreedAiReportDisclaimerIds, setOpenTabs, openTabs]);

    const handleSectionReportLinkClick = useCallback((event, section, isQuestion = false, data = null) => {
        if (!section) {
            event?.preventDefault();
            return;
        }

        // Check if report exists for this section/question
        const hasReport = hasSectionReport(section, isQuestion, data);
        if (!hasReport) {
            event?.preventDefault();
            return;
        }

        if (hasAgreedAiReportDisclaimer) {
            const sectionTab = getSectionTabName(section, isQuestion, data);
            if (sectionTab) {
                setTab(sectionTab);
                // Use setTimeout to ensure hash is set after React state updates and any useEffect hooks complete
                // Use history.replaceState to ensure the hash persists without triggering navigation
                setTimeout(() => {
                    const hashValue = `#${sectionTab}`;
                    if (window.location.hash !== hashValue) {
                        window.history.replaceState(null, '', window.location.pathname + window.location.search + hashValue);
                    }
                }, 100);
            }
            return;
        }

        event.preventDefault();
        const navigationData = { section, isQuestion, data };
        setSectionToNavigate(navigationData);
        sectionToNavigateRef.current = navigationData; // Also store in ref for reliable access
        dispatch(toggleModal({ open: 'DisclaimerAIReportModal' }));
    }, [dispatch, hasAgreedAiReportDisclaimer, setTab, hasSectionReport, getSectionTabName]);

    useEffect(() => {
        if (processing && location.hash && location.hash === "#repository" && showAlert) {
            dispatch(toggleModal({ open: 'repositoryAlert' }))
        }
    }, [processing, location.hash, showAlert])

    let sectionRefs = useRef([]);
    let fileImportRef = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            const sectionPositions = sectionRefs.current.map(ref => {
                const id = ref?.id?.split('.')[0];
                const top = Math.floor(ref?.getBoundingClientRect().top);
                return { id, top };
            });
            const currentActiveSection = sectionPositions.find(position => position?.['top'] >= 0 && position.top < window.innerHeight);
            if (currentActiveSection) setVisibleSection(currentActiveSection.id);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handleEditDispatch = (action) => {
        dispatch(setRModalData({ ...action }))
        dispatch(setOpenRModal(true))
    };

    const syncDrive = async (sectionId, qNo) => {
        if (syncing) return showMessage("Please wait! Syncing is under process")
        dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        console.log(body['newUpgradeSync'], "body['newUpgradeSync']")
        const res = await postRequest(`${syncApiBase}/syncGDriveDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
        }
        window.location.reload();
        dispatch(setDataroomConfig({ syncing: false, message: null }))
    };

    const syncDropbox = async (sectionId, qNo) => {
        if (syncing) return showMessage("Please wait! Syncing is under process")
        dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await postRequest(`${syncApiBase}/syncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch(setDataroomConfig({ syncing: false, message: null }))
    };

    const reverseSyncDropbox = async (sectionId, qNo) => {
        if (syncing) return showMessage("Please wait! Syncing is under process")
        dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        // setNewUpgradeSync(true);
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await postRequest(`${syncApiBase}/reSyncDropBoxDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch(setDataroomConfig({ syncing: false, message: null }))
    };

    const syncSharePoint = async (sectionId, qNo) => {
        if (syncing) return showMessage("Please wait! Syncing is under process")
        dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await postRequest(`${syncApiBase}/syncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch(setDataroomConfig({ syncing: false, message: null }))
    };


    const reSyncSharePoint = async (sectionId, qNo) => {
        if (syncing) return showMessage("Please wait! Syncing is under process")
        dispatch(setDataroomConfig({ syncing: true, message: "Files are currently syncing" }))
        let body = {};
        if (sectionId) body['sectionId'] = sectionId;
        if (qNo) body['qNo'] = qNo;
        body['tab'] = tab;
        body['newUpgradeSync'] = company['syncAfterUpgrade'];
        const res = await postRequest(`${syncApiBase}/reSyncSharePointDataroom/${companyId}`, body, true);
        if (!res) return;
        if (tab) reloadModule(tab, false, false, true);
        // showMessage(res['message']);
        if (newUpgradeSync) {
            setNewUpgradeSync(false);
            window.location.reload();
        }
        dispatch(setDataroomConfig({ syncing: false, message: null }))
    };

    useEffect(() => {
        if (questionsAndAnswersToSave.length) {
            if (isSaving) setSaveTimeout(setTimeout(() => setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]), 1000));
            else save()
        }
    }, [questionsAndAnswersToSave, isSaving]);

    const confirmDeleteFile = async (from) => {
        if (deleteFileLoading) return
        setDeleteFileLoading(true)
        let directorId = undefined;
        if (tab.includes('directors-questionnaire')) {
            const dqs = tab.split('_');
            if (dqs.length > 1) directorId = dqs[1];
        }
        const deletePayload = { file: deleteFile, questionId: deleteFileQuestionId, companyId };
        if (directorId) deletePayload.directorId = directorId;
        const res = await postRequest('/modules/temp-answers/delete-file', deletePayload);
        setDeleteFileLoading(false)
        if (!res || res['code'] != 200) return;

        showMessage(res['message']);

        // Update localModule to remove the file without a full API refetch
        const deletedFileKey = deleteFile?.key;
        const deletedQuestionId = deleteFileQuestionId;
        if (deletedFileKey && deletedQuestionId) {
            setLocalModule(prev => {
                if (!prev) return prev;
                const clone = JSON.parse(JSON.stringify(prev));
                for (const sec of clone.sections) {
                    const qi = sec.questions?.findIndex(q =>
                        q._id === deletedQuestionId || q._id?.toString() === deletedQuestionId?.toString()
                    );
                    if (qi >= 0) {
                        const q = sec.questions[qi];
                        if (q.answer?.files) {
                            q.answer.files = q.answer.files.filter(f => f.key !== deletedFileKey);
                            if (q.answer.files.length === 0 && q.answer.radioOption === 'Yes') {
                                q.answer.status = 'In Progress';
                            }
                        }
                        break;
                    }
                }
                return recomputeLocalStats(clone);
            });
        }

        if (section) {
            let _sections = { ...section }
            _sections.files = section.files?.filter(f => f.key != deleteFile.key);
            setSection(_sections);
            setRefresh(!refresh);
        }

        dispatch(toggleModal({ open: from }));
    };

    const confirmDeleteUnallocatedFile = async () => {
        const res = await postRequest('/modules/deleteUnallocatedFile', { fileReportId: deleteUnallocatedFile.id, file: deleteUnallocatedFile.file, companyId });
        if (!res || res['code'] != 200) return;

        dispatch(setUnallocatedFiles(unallocatedFiles.filter(f => f.file.key != deleteUnallocatedFile.file.key)));
        showMessage(res['message']);
        dispatch(toggleModal({ open: 'unallocatedFiles' }));
    };

    const onDragOver = e => e.preventDefault();
    const onDrop = (e, question, qNo) => {
        if (!company['uploadedFile'] || !company['syncRequired']) {
            dispatch(setCompany({
                ...company,
                uploadedFile: true,
                syncRequired: true
            }));
        }

        e.preventDefault();
        e.target.files = e.dataTransfer.files;
        const fileInput = e.currentTarget.querySelector("input[type='file']");
        if (fileInput) {
            fileInput.value = null; // Reset the input field
        }
        saveAnswer(e, question, qNo);
    };

    const radioButtonChanged = (e, question, qNo, moduleType) => {
        const isOpenModule = activeModule?.isInvestorMatch || activeModule?.isInvestmentReadiness;
        const customSlotNoPermissionOk = isCustomTempSectionNo(qNo);
        if (!isOpenModule && !customSlotNoPermissionOk && company['creatorId']['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
            if (user['role'] == 'Advisor' && (!company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]] && !company['advisors']?.[user['_id']]?.['modules']?.[qNo.split('.').slice(0, 2).join('.')])) return showMessage('To access this module please contact your account admin');
            if (user['role'] == 'Investor' && (!company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.')[0]] && !company['investors']?.[user['_id']]?.['modules']?.[qNo.split('.').slice(0, 2).join('.')])) return showMessage('To access this module please contact your account admin');
            if (user['role'] == 'Member' && (!company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.')[0]] && !company?.['memberPermissions']?.[user['_id']]?.[qNo.split('.').slice(0, 2).join('.')])) return showMessage('To access this module please contact your account admin');
        }

        // question = Object.freeze(question);
        question = JSON.parse(JSON.stringify(question));

        const option = e['target']['dataset']['option'];
        const wrapper = e['target'].closest("[data-question-id]")
        //TODO: change to toggleHeight
        for (const showOrHideEl of wrapper.querySelectorAll(".showOrHide"))
            if (option === "Yes" || option == 'Disclosure') {
                showOrHideEl.classList.remove("dn");
                setTimeout(() => showOrHideEl.classList.remove("op0", "h0"), 100);
            } else {
                showOrHideEl.classList.add("op0", "h0");
                setTimeout(() => showOrHideEl.classList.add("dn"), 300);
            }

        // Send only update keys
        if (!question['answer'] || question['answer'] == undefined) question['answer'] = {};
        else question['answer'] = { _id: question['answer']['_id'], status: question['answer']['status'] };

        question['answer']['radioOption'] = option;
        if (option == 'No') question['answer']['status'] = 'Completed';
        // else if (option == 'N/A') question['answer']['status'] = 'Not Applicable';
        else if (['T', 'Date', 'DropDown'].includes(question['questionType'])) {
            question['answer']['status'] = 'Completed';
            question['answer']['radioOption'] = 'Yes';
        } else if ((question['questionType'].includes('F')) || (option == 'Disclosure' && moduleType == 'warranty-disclosure')) {
            question['answer']['status'] = question['answer']['status'] ?? 'In Progress';
        } else question['answer']['status'] = 'Completed';
        if (!question['updatedBy']) window.scrollTo({ top: window['scrollY'] + 150, behavior: 'smooth' });

        if (["Yes", "No", "N/A"].includes(option) && tab.includes('two-minute-test')) {
            question['answer']['status'] = 'Completed';
        }
        if (tab === 'investor-lead') {
            question['answer']['status'] = 'Completed';
        }

        // Immediately patch localModule so React re-render keeps the correct showFiles state
        // (prevents the dn class from being re-applied before the save round-trip completes)
        const newRadioOption = question['answer']['radioOption'];
        const newStatus = question['answer']['status'];
        setLocalModule(prev => {
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const sec of clone.sections) {
                const qi = sec.questions?.findIndex(q =>
                    q._id === question['_id'] || q._id?.toString() === question['_id']?.toString()
                );
                if (qi >= 0) {
                    const q = sec.questions[qi];
                    q.answer = q.answer || {};
                    q.answer.radioOption = newRadioOption;
                    if (newStatus) q.answer.status = newStatus;
                    break;
                }
            }
            return recomputeLocalStats(clone);
        });

        saveAnswer(e, question, qNo, 'radio');
    };

    const cloneFile = (file) => {
        const clonedFile = new File([file], file['name'], { type: file['type'] });
        return clonedFile;
    };

    const handleFileChange = async (e) => {
        if (e['target'].files.length > 80) {
            return showMessage("Oops! You can upload up to 80 files at a time. Please try again with fewer files.");
        }
        dispatch(toggleModal({ open: 'computerToClarence', percent: 0 }));
        attachment = [];
        let relPaths = [], filesInfo = [];
        setFAMenuVisible(false);
        let percent = 0, filesUploaded = 0;
        const totalFiles = e['target']['files'].length;
        for (const file of e['target'].files) {
            relPaths.push(file.webkitRelativePath);
            const clonedFile = cloneFile(file);
            attachment = [clonedFile];
            const uploadEndpoint = `/modules/uploadFile`
            const res = await postRequest(uploadEndpoint, { attachment });
            if (!res) continue;
            if (!res.body?.['report']) continue;
            filesInfo.push(res['body']['report']);
            filesUploaded = filesUploaded + 1;
            percent = Math.round((filesUploaded / totalFiles) * 100);
            dispatch(toggleModal({ open: 'computerToClarence', percent, fileName: file['name'], totalFiles, filesUploaded }));
        }

        e['target']['value'] = null;
        dispatch(toggleModal({ open: 'allocatingFiles' }));
        const uploadFilesEndpoint = `/modules/uploadFiles`
        const uploadFilesPayload = { files: filesInfo, companyId, moduleId: activeModule?._id, relPaths }
        const res = await postRequest(uploadFilesEndpoint, uploadFilesPayload);
        if (!res) return;
        if (!res['body']?.['report']) return;
        showMessage(res['message']);
        dispatch(setFileReport(res['body']['report']));
        setCloneImportResult(JSON.parse(JSON.stringify(res['body']['report']['importResult'])));
        const allocated = Object.keys(res['body']['report']['importResult']).filter(key => res['body']['report']['importResult'][key]['section'].some((element) => !element.includes("DXXX"))).length;
        // DXXX
        const total = Object.keys(res['body']['report']['importResult']).length;
        e['target']['value'] = '';
        dispatch(toggleModal({ open: 'tempImportSummary', from: '' }))
        dispatch(
            updateFileAllocation({
                fileReport: res.body['report'],
                company,
                currentScore: total == 0 ? 0 : Math.round(allocated / total * 100),
                reportHistories,
                profileClass,
                moduleId: activeModule?._id || null,
            }))
    };

    const strAdditionalSections = (() => {
        const customSections = (activeModule?.sections || []).filter(
            s => s.companyId && s.type === 'Additional Sections'
        );
        const saved = customSections.map(s => [s._id, s.sectionName, true, true]);
        const empty = Array.from({ length: Math.max(0, 5 - saved.length) }, () => [null, '', false, true]);
        return [...saved, ...empty];
    })();

    let [additionalSections, setAdditionalSections] = useState(strAdditionalSections);
    const [isSectionNameDuplicate, setIsSectionNameDuplicate] = useState({ indexes: [], name: '' })

    const findDuplicates = (arr) => {
        const map = arr.reduce((acc, [index, name]) => {
            if (name !== "") (acc[name.toLowerCase().trim()] = acc[name.toLowerCase().trim()] || []).push(index);
            return acc;
        }, {});

        for (const [name, indexes] of Object.entries(map)) {
            if (indexes.length > 1) return { indexes, name };
        }

        return { indexes: [], name: '' };
    };

    function editSectionName(strVal, index) {
        let newArray = [...additionalSections];
        newArray[index][1] = strVal;
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray)
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({ indexes: [], name: '' })
    };

    function onEdit(index) {
        let newArray = [...additionalSections];
        if (newArray[index][3] === true && newArray[index][1] === "") return showMessage('Please input additional user-defined sections name!');
        newArray[index][3] = !newArray[index][3];
        setAdditionalSections(newArray);
        const newSetData = findDuplicates(newArray)
        newSetData.indexes.length ? setIsSectionNameDuplicate(newSetData) : setIsSectionNameDuplicate({ indexes: [], name: '' })
    };

    async function onDelete(index) {
        const sectionId = additionalSections[index][0];

        // Unsaved new slot — just clear it
        if (!sectionId) {
            setAdditionalSections(prev => {
                const next = [...prev];
                next[index] = [null, '', false, true];
                return next;
            });
            return;
        }

        try {
            const resp = await deleteRequest(`/modules/temp-sections/custom/${sectionId}`);
            if (resp?.code === 200) {
                // Replace deleted slot with empty slot (maintain 5 total)
                setAdditionalSections(prev => {
                    const next = [...prev];
                    next[index] = [null, '', false, true];
                    return next;
                });
                // Remove section from localModule immediately (no full refetch needed)
                setLocalModule(prev => {
                    if (!prev) return prev;
                    const clone = JSON.parse(JSON.stringify(prev));
                    clone.sections = clone.sections.filter(s => s._id?.toString() !== sectionId?.toString());
                    return recomputeLocalStats(clone);
                });
                showMessage(resp.message);
                dispatch(toggleModal({ open: '' }));
            }
        } catch (err) { console.log(err) }
    };

    const onSaveAdditionalSections = async () => {
        if (isSectionNameDuplicate.indexes.length && isSectionNameDuplicate.name !== '') return;

        // Only process entries that have a name and no _id yet (new, unsaved sections)
        const newEntries = additionalSections.filter(s => !s[0] && s[1].trim());
        if (!newEntries.length) return showMessage('Please enter at least one new section name.');

        if (!activeModule?._id) return showMessage('Module not found. Please reload the page.');

        const results = await Promise.all(
            newEntries.map(s => postRequest('/modules/temp-sections/custom', {
                moduleId: activeModule._id,
                sectionName: s[1].trim(),
                companyId,
            }))
        );

        const failed = results.filter(r => !r || r.code !== 200);
        if (failed.length) {
            showMessage(failed[0]?.message || 'Failed to create one or more sections.');
            return;
        }

        // Add newly created sections to localModule immediately (append at end)
        const created = results.map(r => r.body);
        setLocalModule(prev => {
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            for (const { section, question } of created) {
                clone.sections.push({
                    ...section,
                    questions: [{ ...question, answer: { radioOption: 'NC', status: 'Not Started', files: [], logs: [], taskNotes: [], aiResponse: {}, comment: '', dropdown: '', date: null } }],
                    stats: { completionPercent: 0, totalQuestions: 1, completedQuestions: 0, riskScore: 0 },
                });
            }
            return recomputeLocalStats(clone);
        });

        // Refresh additionalSections — maintain exactly 5 slots
        setAdditionalSections(prev => {
            const createdMap = new Map(created.map(c => [c.section.sectionName.trim(), c.section]));
            const next = prev.map(s => {
                if (!s[0] && s[1].trim() && createdMap.has(s[1].trim())) {
                    const sec = createdMap.get(s[1].trim());
                    return [sec._id, sec.sectionName, true, true];
                }
                return s;
            });
            return next;
        });

        showMessage('Section saved successfully.');
        dispatch(toggleModal({ open: '' }));
    };

    const saveAnswer = (e, question, sectionNo, type) => {
        const customSaveOk =
            isCustomTempSectionNo(question?.qNo) ||
            isCustomTempSectionNo(sectionNo);
        if (permissionLevel == 'DASHBOARD' && !customSaveOk) {
            showMessage('To access this module please contact your account admin');
            return;
        }

        const permNo = question?.qNo || sectionNo;
        const isOpenModuleForSave = activeModule?.isInvestorMatch || activeModule?.isInvestmentReadiness;
        const customSlotOkForSave = isCustomTempSectionNo(permNo);
        if (permNo && !isOpenModuleForSave && !customSlotOkForSave && company['creatorId']['_id'] != user['_id'] && company['addedByInvestor'] != user['_id'] && (company['servicedBy']['_id'] || company['servicedBy']) != user['_id'] && company['cCategory'] == 'client' && !companyIndex) {
            if (user['role'] == 'Advisor' && (!company['advisors']?.[user['_id']]?.['modules']?.[permNo.split('.')[0]] && !company['advisors']?.[user['_id']]?.['modules']?.[permNo.split('.').slice(0, 2).join('.')])) {
                showMessage('To access this module please contact your account admin');
                return;
            }
            if (user['role'] == 'Investor' && (!company['investors']?.[user['_id']]?.['modules']?.[permNo.split('.')[0]] && !company['investors']?.[user['_id']]?.['modules']?.[permNo.split('.').slice(0, 2).join('.')])) {
                showMessage('To access this module please contact your account admin');
                return;
            }
            if (user['role'] == 'Member' && (!company?.['memberPermissions']?.[user['_id']]?.[permNo.split('.')[0]] && !company?.['memberPermissions']?.[user['_id']]?.[permNo.split('.').slice(0, 2).join('.')])) {
                showMessage('To access this module please contact your account admin');
                return;
            }
        }

        let subAnswers;
        if (question['qNo'] == 'DEPF008.3.1' && question?.['answer']?.['subAnswers']) subAnswers = question['answer']['subAnswers']

        question = JSON.parse(JSON.stringify(question));
        const priorAnswerStatus = question?.answer?.status;
        // Send only update keys
        if (type != 'radio' && question['answer']) question['answer'] = { _id: question['answer']['_id'] };

        if (['T', 'F/T', 'Date', 'DropDown', 'Radio', 'Multi'].includes(question['questionType'])) {
            question['answer'].status = 'Completed';
            question['answer'].radioOption = 'Yes';
        }
        console.log('question[questionType] = 1000 ', question['answer']);
        if (['YN/F/T'].includes(question['questionType']) && question['answer'].radioOption == 'N/A') {
            question['answer'].status = 'Completed';
        }
        clearTimeout(saveTimeout);
        let questionAndAnswerToSave = questionsAndAnswersToSave.find(q => q._id == question['_id']);
        if (!questionAndAnswerToSave) {
            // Extract directorId from tab for director-wise temp modules
            let directorIdFromTab = undefined;
            if (tab && tab.includes('directors-questionnaire_')) {
                const tabParts = tab.split('_');
                if (tabParts.length > 1) directorIdFromTab = tabParts[1];
            }
            questionAndAnswerToSave = {
                ...question,
                sectionNo,
                moduleType: question['type'],
                answer: {
                    _id: question.answer?._id,
                    fileIndexes: [],
                    logs: question.answer?.logs,
                    ...question.answer,
                    ...(directorIdFromTab && !question.answer?.directorId && { directorId: directorIdFromTab })
                }
            };
            if (question?.['answer']?.['status']) questionAndAnswerToSave['answer']['status'] = question['answer']['status'];
            questionsAndAnswersToSave.push(questionAndAnswerToSave);
        }

        if (question['qNo'] == 'DEPF008.3.1') {
            if (!questionAndAnswerToSave['answer']['subAnswers']) questionAndAnswerToSave['answer']['subAnswers'] = {};
            if (subAnswers) questionAndAnswerToSave['answer']['subAnswers'] = { ...subAnswers, [e.target.name]: e.target.value };
            else questionAndAnswerToSave['answer']['subAnswers'][e.target.name] = e.target.value;
        }
        else if (question['questionType'] == 'Radio') questionAndAnswerToSave.answer['dropdown'] = e.target.dataset.option;
        else if (question['questionType'] == 'Multi') {
            let answer = '';
            e.target.value.map(value => {
                if (value.length == 0) return;
                if (answer.length > 0) answer = answer + ';' + value;
                else answer = value;
            })
            questionAndAnswerToSave.answer[e.target.name] = answer;
        }
        else if (e.target.dataset && e.target.dataset.option) {
            questionAndAnswerToSave.answer.radioOption = e.target.dataset.option;
        }
        else if (e.target.files) {
            for (const file of e.target.files) {
                let index = attachment.push(file) - 1;
                questionAndAnswerToSave.answer.fileIndexes.push(index);
            }
            //showMessage("Uploading files");
            if (!company['uploadedFile'] || !company['syncRequired']) {
                dispatch(setCompany({
                    ...company,
                    uploadedFile: true,
                    syncRequired: true
                }));
            }
            if (question['questionType'] == 'D/ND') questionAndAnswerToSave.answer.radioOption = 'Disclosure';
            else {
                questionAndAnswerToSave.answer.radioOption = 'Yes';
            }
        }
        else if (e.target.type === "checkbox") {
            questionAndAnswerToSave.answer.status = e.target.checked ? "Completed" : "In Progress";
            if (!question['answer']['_id']) {
                questionAndAnswerToSave.answer.radioOption = question['questionType'] == 'D/ND' ? 'Disclosure' : 'Yes';
            }
        } else questionAndAnswerToSave.answer[e.target.name] = e.target.value || e.target.checked;

        const curSaveStatus = questionAndAnswerToSave.answer.status;
        const isCompletedLikeSave = curSaveStatus === 'Completed' || curSaveStatus === 'Not Applicable';
        if (!isCompletedLikeSave) {
            if (priorAnswerStatus === 'Not Started' || priorAnswerStatus === undefined || priorAnswerStatus === null || priorAnswerStatus === '') {
                questionAndAnswerToSave.answer.status = 'In Progress';
            } else if ((curSaveStatus === undefined || curSaveStatus === null || curSaveStatus === '') && priorAnswerStatus) {
                questionAndAnswerToSave.answer.status = priorAnswerStatus;
            }
        }

        if (tab === 'investor-lead' && e.target.type !== 'checkbox') {
            questionAndAnswerToSave.answer.status = 'Completed';
            if (type !== 'radio') {
                const qId = question['_id'];
                setLocalModule(prev => {
                    if (!prev) return prev;
                    const clone = JSON.parse(JSON.stringify(prev));
                    for (const sec of clone.sections) {
                        const qi = sec.questions?.findIndex(q =>
                            q._id === qId || q._id?.toString() === qId?.toString()
                        );
                        if (qi >= 0) {
                            sec.questions[qi] = { ...sec.questions[qi], answer: { ...sec.questions[qi].answer, status: 'Completed' } };
                            break;
                        }
                    }
                    return recomputeLocalStats(clone);
                });
            }
        }
        if (e.target.files) setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]);
        else setSaveTimeout(setTimeout(() => setQuestionsAndAnswersToSave(questionsAndAnswersToSave => [...questionsAndAnswersToSave]), 10));
    };

    const save = async () => {
        setIsSaving(true);
        setQuestionsAndAnswersToSave([]);
        let currentCount = 0, percent = 0, filesInfo = [];
        const totalFileCount = attachment.length;
        for (const file of attachment) {
            const res = await postRequest(`/question/newUploadFile`, { attachment: [file] }, true);
            if (!res) continue;
            if (!res.body?.['result']) continue;
            currentCount++;
            filesInfo.push(res.body['result']);
            percent = Math.round((currentCount / totalFileCount) * 100);
            dispatch(toggleModal({ open: 'computerToDataRepository', percent, fileName: file['name'], totalFiles: totalFileCount, filesUploaded: currentCount }));
        }

        const currentCompanyId = localStorage.getItem('companyId') || companyId;

        const isLegacyModule = activeModule?.isInvestmentReadiness || activeModule?.isInvestorMatch;
        const saveEndpoint = isLegacyModule ? '/question/newSaveAnswers' : '/modules/temp-answers/save';

        const res = await postRequest(saveEndpoint, {
            files: filesInfo,
            companyId: currentCompanyId,
            questionsAndAnswersToSave,
        });
        dispatch(toggleModal({ open: '' }));
        if (!res || res['code'] != 200) { setIsSaving(false); return; }

        const { answerErrors = {}, savedQuestions = [] } = res['body'];

        if (answerErrors && Object.keys(answerErrors).length > 0) {
            Object.values(answerErrors).forEach(msg => showMessage(msg));
        }

        if (savedQuestions.length > 0) {
            updateLocalAnswers(savedQuestions);
            // Broadcast saved answers to the sidebar so its progress bars update immediately
            // without requiring a page refresh. SidebarIndexNew listens to tempModuleAllocationPatch.
            if (activeModule?._id) {
                dispatch(updateFileAllocation({
                    tempModuleAllocationPatch: { moduleId: String(activeModule._id), savedQuestions },
                }));
            }
        }

        setAttachment([]);
        setIsSaving(false);
        showMessage(res['message']);
        spinner?.classList?.add("op0");
    };

    const onClickDeduperAuditLog = async () => {
        const res = await getRequest(`/company/getDeduperReportLog/${companyId}`);
        dispatch(setLogList(res['body']))
        dispatch(toggleModal({ open: 'deduperReportAuditLog' }))
    };

    const onClickUnallocatedBinAuditLog = async () => {
        const res = await getRequest(`/company/getUnallocatedBinLog/${companyId}`);
        dispatch(setLogList(res['body']))
        dispatch(toggleModal({ open: 'unallocatedBinAuditLog' }))
    };

    const moveUnallocatedFile = async ({ payload }) => {
        if (payload.length) {
            const res = await postRequest('/modules/moveUnallocateFiles', {
                payload,
                companyId,
                moduleId: activeModule._id,
                tab
            });
            if (!res || res['code'] != 200) return;

            const savedQuestions = res?.body?.savedQuestions || [];
            if (savedQuestions.length > 0) {
                updateLocalAnswers(savedQuestions);
                dispatch(updateFileAllocation({
                    tempModuleAllocationPatch: { moduleId: String(activeModule._id), savedQuestions },
                }));
            }
            showMessage(res['message']);
            const filteredUnallocatedFiles = unallocatedFiles.filter(uf => !uf?.sectionNo);
            dispatch(setUnallocatedFiles(filteredUnallocatedFiles));
            setRefresh(!refresh);
            dispatch(toggleModal({ open: "" }))
        } else {
            showMessage('Please select target section');
        }
    };

    const moveDeduperFile = async ({ payload }) => {
        if (payload.length) {
            const isTempModule = !!activeModule?._id;
            const endpoint = '/modules/moveDeduperFile'
            const body = isTempModule
                ? { companyId, moduleId: activeModule._id, actions: payload }
                : { companyId, tab, actions: payload };

            const res = await postRequest(endpoint, body);
            if (!res || res['code'] != 200) return;

            if (tab) await reloadModule(tab, true);
            showMessage(res['message']);

            if (isTempModule) {
                // Modules response: { results: [...] } — no DeduperReport
                setRefresh(!refresh);
            } else {
                const newReport = res['body'];
                dispatch(setDeduperFiles(JSON.parse(JSON.stringify(newReport))));
                let curSection = {};
                for (const dupFiles of Object.values(newReport.deduperResult || {})) {
                    if (!Array.isArray(dupFiles)) continue;
                    for (const dupFile of dupFiles) {
                        if (dupFile?.file?.key) {
                            curSection[dupFile.file.key] = { qNo: dupFile.qNo, name: dupFile.name };
                        }
                    }
                }
                dispatch(setTargetSection(curSection));
                setRefresh(!refresh);
            }
        } else {
            showMessage('Please select target section');
        }
    };

    const onClickFileReportHistory = async () => {
        setFAMenuVisible(false);
        const res = await getRequest(`/company/getFileReportHistory/${companyId}`);
        setReportHistories(res['body']);
        dispatch(toggleModal({ open: 'fileReportHistory' }))
    };

    const showDeduperReport = (report) => {
        // setDupCheck(JSON.parse(JSON.stringify(report)));
        // setDupCheck(report);
        dispatch(setDeduperFiles(report))
        let curSection = {};
        if (report?.deduperResult && typeof report.deduperResult === "object") {
            for (const dupFiles of Object.values(report.deduperResult)) {
                if (!Array.isArray(dupFiles)) continue;

                for (const dupFile of dupFiles) {
                    if (dupFile?.file?.key) {
                        curSection[dupFile.file.key] = {
                            qNo: dupFile.qNo,
                            name: dupFile.name
                        };
                    }
                }
            }
        }
        dispatch(setTargetSection(curSection));
        dispatch(toggleModal({ open: 'duplicationCheckSummary' }));
    };

    const onClickDeduperReportHistory = async () => {
        setFAMenuVisible(false);
        const res = await getRequest(`/company/getDeduperReportHistory/${company['_id']}`);
        if (res && res.body && !res['body'].length) {
            return checkDuplicatedFiles()
        }
        if (res['body'] && Array.isArray(res['body']) && res['body'].length > 0) {
            showDeduperReport(res['body'][0]);
        } else {
            showDeduperReport({});
        }
        // setDeduperHistories(res['body']);
        // dispatch(toggleModal({ open: 'deduperReportHistory' }))
    };

    const handleToggleSuccessAiReportGeneratedModal = async (redirect) => {
        // Close the success modal first
        dispatch(toggleModal({ open: '' }));

        // If user wants to view the report, show disclaimer
        // Navigation will be handled in handleAiReportDisclaimerClose after user clicks "Understood"
        if (redirect) {
            dispatch(toggleModal({ open: 'DisclaimerAIReportModal' }));
        }
    }


    const generateInsuranceAiReport = async ({ data, isQuestion }) => {
        setFAMenuVisible(false);
        const allFiles = isQuestion ? [...(data.answer.files.map(file => file.location) || [])] : (data?.questions || data?.section?.questions).flatMap(q => q.answer.files.map(file => file.location) || []).filter(Boolean);
        const generatingKey = getReportGenerationKey(data, isQuestion);
        const requestId = startReportGenerationLoading(generatingKey);

        if (!companyObjectId) {
            showMessage('Unable to generate analysis report. Missing company identifier.');
            stopReportGenerationLoading(requestId);
            return;
        }

        showMessage(`The report generation process is in progress and may take approximately 8 to 10 minutes to complete.`)

        try {
            const sectionId = isQuestion ? data.sectionId : (data?.['_id'] || data.section._id);

            const res = await postRequest(`${syncApiBase}/generateSectionReport/${companyObjectId}/${sectionId}`, {
                "companyId": companyObjectId,
                "files": allFiles,
                "query": 'You are a legal diligence report writer. Follow instructions strictly.',
                "isQuestion": isQuestion,
                ...(isQuestion ? { data } : {})
            });


            // if (true) {
            if (res?.['code'] == 200) {
                showMessage(res['message']);

                const reportType = res?.body?.reportType || null;
                expectedReportTypeRef.current = reportType
                let sectionData = null;
                if (isQuestion && data?.sectionId) {
                    // Try to find the section from company data using sectionId
                    if (company?.modules) {
                        for (const module of Object.values(company.modules)) {
                            if (module?.sections) {
                                sectionData = Object.values(module.sections).find(
                                    sec => sec._id === data.sectionId || sec._id?.toString() === data.sectionId?.toString()
                                );
                                if (sectionData) break;
                            }
                        }
                    }
                } else if (!isQuestion) {
                    // For section reports, data is the section itself
                    sectionData = data;
                }

                // Store navigation data (section may be null for questions, but we have qNo in data)
                const anchor = (sectionData?.sectionNo || sectionData?.no || data?.sectionNo || data?.qNo || null);
                if (anchor) {
                    lastReportAnchorRef.current = anchor;
                    try {
                        localStorage.setItem('lastReportAnchor', anchor);
                    } catch (_) { /* ignore */ }
                }
                setSectionToNavigate({ section: sectionData, isQuestion, data });
                sectionToNavigateRef.current = { section: sectionData, isQuestion, data };

                dispatch(toggleModal({ open: 'successAiReportGenerated' }))
            } else {
                showMessage(res?.['message'] || 'Unable to generate analysis report');
            }
        } catch (error) {
            showMessage(error?.message || 'Unable to generate analysis report');
        } finally {
            stopReportGenerationLoading(requestId, { force: true });
            setTimeout(() => {
                if (isComponentMountedRef.current) {
                    const loadingMap = getPersistedReportLoadingMap();
                    const entry = loadingMap[companyObjectId];
                    if (!entry || entry.status !== 'pending') {
                        setReportGenerateLoadingState(null);
                        reportGenerationRequestRef.current = null;
                    }
                }
            }, 200);
        }
    };

    const onClickViewUnallocatedFiles = async () => {
        setFAMenuVisible(false);
        const res = await getRequest(`/modules/unallocatedFiles/${companyId}`);
        dispatch(setTargetSection({}));
        dispatch(setUnallocatedFiles(res['body']['unallocated']));
        dispatch(toggleModal({ open: 'unallocatedFiles' }));
    };

    const checkDuplicatedFiles = async () => {
        setFAMenuVisible(false);
        dispatch(toggleModal({ open: 'checkingDuplication' }));
        const isTempModule = !!activeModule?._id;
        const payload = isTempModule
            ? { companyId, moduleId: activeModule._id }
            : { companyId, tab };
        const res = await postRequest(`/modules/checkDuplicate`, payload);
        showDeduperReport(res?.['body'] || {});
    };

    const getViewableURL = (url) => {
        window.open(url, "_blank");
    };

    const getDeduperReportLogsHTML = (logs) => logs.map((log, idx) => {
        if (!log['files']) return <> </>
        else return (
            <div key={`deduper-log-${idx}-${log.timestamp}`} className="df my0-5rem">
                {log?.['userId']?.['profile']
                    && <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
                    || <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
                }
                <div className="w100">
                    <span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

                    {log['files'].length > 0 && <>
                        <p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`deduper-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
                    </>
                    }

                    {log?.['change'] &&
                        <div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
                            <p><b>Comment</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
                        </div>
                    }
                </div>
            </div>
        )
    });

    const getFileReportLogsHTML = (logs) => logs.map((log, idx) => {
        if (!log['files']) return <> </>
        else return (
            <div key={`file-report-log-${idx}-${log.timestamp}`} className="df my0-5rem">
                {log?.['userId']?.['profile']
                    && <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
                    || <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
                }
                <div className="w100">
                    <span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

                    {log['files'].length > 0 && <>
                        <p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`file-report-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
                    </>
                    }
                    {log?.['change'] &&
                        <div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
                            <p className=""><b>Changed Status</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
                            <p><b>Assistant Accuracy</b>: {log?.['change']?.accuracy != undefined ? log?.['change']?.accuracy : '-'}%</p>
                            {/* <p><b>Updated Comment</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p> */}
                        </div>
                    }
                </div>
            </div>
        )
    });

    const getUnallocatedBinLogsHTML = (logs) => logs.map((log, idx) => {
        if (!log['files']) return <> </>
        else return (
            <div key={`unallocated-bin-log-${idx}-${log.timestamp}`} className="df my0-5rem">
                {log?.['userId']?.['profile']
                    && <img className={`ass mr0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
                    || <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
                }
                <div className="w100">
                    <span className='fs0-75rem c15'><b>{log['message']} by {log?.['userId']?.['firstName']} </b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>

                    {log['files'].length > 0 && <>
                        <p className="df fs0-75rem mb0-5rem">Files: {log['files'].map((file, fileIdx) => <div key={`unallocated-bin-log-file-${idx}-${fileIdx}-${file['originalname']}`} onClick={() => getViewableURL(file['location'])} target="_blank" className="db c3-hover fw600 tdu fs0-75rem ml0-5rem cp">{file['originalname']}</div>)}</p>
                    </>
                    }
                    {/* {log?.['change'] &&
						<div className="shadow bg5 br5px p1rem dg gg0-5rem mb0-5rem fs0-75rem">
							<p className=""><b>Changed Status</b>: {log?.['change']?.comment ? log?.['change']?.comment : '-'}</p>
						</div>
					} */}
                </div>
            </div>
        )
    });

    const onClickFileManager = (section, questionIndex) => {
        let curSection = { ...targetSection };
        if (section && section.files && section.files.length > 0) {
            section.files.map(file => {
                curSection[file.key] = { qNo: section.sectionNo || section.no, name: section.sectionName || section.name };
            })
        }
        dispatch(setTargetSection(curSection));

        // Patch fileAllocation.company.modules[tab] with a flat tempQuestions list so
        // the destination picker (openRModal) shows temp questions (qNo + section name)
        if (localModule?.sections) {
            const tempQuestions = [];
            for (const sec of localModule.sections) {
                for (const q of sec.questions || []) {
                    if (q.qNo) tempQuestions.push({
                        qNo: q.qNo,
                        qDescription: q.qDescription || '',
                        sectionNo: sec.sectionNo,
                        sectionName: sec.sectionName || '',
                    });
                }
            }
            const baseCompany = fileAllocationCompany || company;
            dispatch(updateFileAllocation({
                company: {
                    ...baseCompany,
                    modules: {
                        ...(baseCompany?.modules || {}),
                        [tab]: { isTempModule: true, tempQuestions, sections: [] }
                    }
                }
            }));
        }
    };

    const answerSaved = (answer) => {
        let updatedBy = answer?.['updatedBy']?.[0] || answer?.['updatedBy'];

        if (updatedBy?.['firstName']) {
            let answerClass = (updatedBy?.['role'] == 'Advisor' ? 'advisor-profile' : updatedBy?.['role'] == 'Investor' ? 'investor-profile' : 'client-profile');
            return (
                <div className="df my0-5rem">
                    {answer?.['autoFilled']
                        ? <img className="ass mr0-5rem br100 w2rem h2rem" src={require('../../../../../../images/intelligentiaIcon.png')} alt="Clarence" data-tooltip="Auto-filled by Clarence AI" />
                        : (updatedBy?.['profile'] && <img className={`ass mr0-5rem br100 w2rem h2rem ${answerClass}`} src={updatedBy['profile']} data-tooltip={updatedBy['firstName'] ? (updatedBy['firstName'] + " " + updatedBy['lastName']) : "Register to show your name here"} />
                            || <span className={`shadow ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-5rem c15 bg16 ${answerClass}`} data-tooltip={updatedBy?.['firstName'] ? (updatedBy['firstName'] + " " + updatedBy['lastName']) : "Register to show your name here"}>{updatedBy?.['firstName']?.[0] || "?"}{updatedBy?.['lastName']?.[0] || "?"}</span>)
                    }
                    <div className="w100">
                        <span className='fs0-75rem c15'><b>Answer Saved</b>, <b>{moment(answer['updatedAt']).format('lll')}</b></span>
                    </div>
                </div>
            )
        }
    };

    const handleSectionLogs = async (id) => {
        const res = await getRequest(`${logsApiBase}/getLogs/${id}`);
        dispatch(setLogList(res['body']))
        dispatch(toggleModal({ open: 'auditLog' }))
    };

    const openWindow = (url) => {
        if (window.innerWidth <= 640) {
            var a = document.createElement('a');
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");

            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);

            a.dispatchEvent(dispatch);
        }
        else {
            var width = window.innerWidth * 0.8;
            var height = width * window.innerHeight / window.innerWidth;
            window.open(url, 'newwindow', 'width=' + width + ', height=' + height + ', top=' + ((window.innerHeight - height) / 2) + ', left=' + ((window.innerWidth - width) / 2));
        }
        return false;
    };

    const getFilesFromQuestions = questions => questions && questions.filter(q => q.answer?.files?.length)
        .reduce((arr, q) => [...arr, ...q.answer.files.map(file => ({
            ...file,
            questionId: q._id,
            qNo: q.qNo,
            title: file.originalname,
            url: file.location,
            ext: file.originalname.split(".").slice(-1)[0],
        }))], []);

    // Map qNo → question (used for temp move/copy destination lookup)
    const questionByQNo = useMemo(() => {
        if (!localModule?.sections) return {};
        const map = {};
        for (const sec of localModule.sections) {
            for (const q of sec.questions || []) {
                if (q.qNo) map[q.qNo] = q;
            }
        }
        return map;
    }, [localModule]);

    // Move/copy a file between temp module questions without a full module refetch
    const handleTempMoveFile = useCallback(async ({ file, qNo, curQno, isCut, sectionName }) => {
        // Investment Readiness & Investor Match/Lead use the legacy non-temp moveFile
        // endpoint because their answers live on the regular Company modules tree,
        // not in TempAnswer. Route those tabs to /company/moveFile and refetch.
        const isLegacyMoveFileTab = tab === 'Investment Readiness' || tab === 'investor-lead';
        if (isLegacyMoveFileTab) {
            const res = await postRequest('/company/moveFile', {
                file,
                unallocated: false,
                companyId,
                isCut,
                qNo,
                tab,
                oldQno: curQno,
                isDeduper: false,
                key: file.key,
                sectionName,
            });
            if (!res || res['code'] !== 200) {
                showMessage(res?.message || 'Move/copy failed');
                return;
            }
            showMessage(res['message']);
            if (reloadModule) reloadModule(tab, false, false, true);
            return;
        }

        // source: file.questionId is already the MongoDB _id (set by getFilesFromQuestions)
        const fromQuestionId = file?.questionId ?? curQno;

        // Primary lookup: exact qNo match (standard sections and new custom sections use sectionNo as qNo).
        // Fallback: legacy custom sections stored qNo as '<sectionNo>.Q1' — try the first child question
        // whose qNo starts with '<sectionNo>.' so moves still work for pre-existing documents.
        let toQuestion = questionByQNo[qNo];
        if (!toQuestion) {
            const prefix = qNo + '.';
            toQuestion = Object.values(questionByQNo).find(q => q.qNo && q.qNo.startsWith(prefix));
        }
        if (!toQuestion) {
            showMessage('Destination question not found');
            return;
        }
        const toQuestionId = toQuestion._id;

        const res = await postRequest('/modules/temp-answers/move-file', {
            companyId,
            fromQuestionId,
            toQuestionId,
            fileKey: file.key,
            isCut,
        });

        if (!res || res['code'] !== 200) {
            showMessage(res?.message || 'Move/copy failed');
            return;
        }
        showMessage(res['message']);

        const movedFile = res?.body?.file || file;
        const toAnswerId = res?.body?.toAnswerId;

        setLocalModule(prev => {
            if (!prev) return prev;
            const clone = JSON.parse(JSON.stringify(prev));
            let sourceQ = null, destQ = null;
            for (const sec of clone.sections) {
                for (const q of sec.questions || []) {
                    if (q._id?.toString() === fromQuestionId?.toString()) sourceQ = q;
                    if (q._id?.toString() === toQuestionId?.toString()) destQ = q;
                }
            }
            if (!sourceQ || !destQ) return prev;

            if (isCut) {
                sourceQ.answer = sourceQ.answer || {};
                sourceQ.answer.files = (sourceQ.answer.files || []).filter(f => f.key !== file.key);
                if (sourceQ.answer.files.length === 0 && sourceQ.answer.radioOption === 'Yes') {
                    sourceQ.answer.status = 'In Progress';
                }
            }

            destQ.answer = destQ.answer || {};
            if (toAnswerId) {
                destQ.answer._id = toAnswerId;
            }
            destQ.answer.files = destQ.answer.files || [];
            if (!destQ.answer.files.some(f => f.key === movedFile.key)) {
                destQ.answer.files.push(movedFile);
            }
            if (!['Yes', 'Disclosure'].includes(destQ.answer.radioOption)) destQ.answer.radioOption = 'Yes';
            destQ.answer.status = 'Completed';

            return recomputeLocalStats(clone);
        });
    }, [companyId, questionByQNo, tab, reloadModule]);

    const showRiskRecommendation = (key) => {
        return <h5 className="fs1rem fsi mt2rem df aic c15">
            {key.includes("recommend")
                ? <><svg className="mr0-5rem" width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.0954 10.0946C21.0954 5.89534 17.6873 2.49208 13.4862 2.50001C9.32805 2.50787 5.97026 5.81889 5.90715 9.97656C5.86673 12.6385 7.19613 14.9926 9.23603 16.3795C9.24414 16.385 9.24902 16.3941 9.24902 16.404C9.6515 16.6551 9.8961 17.0961 9.8961 17.5705V19.2815H17.1055V17.555C17.1055 17.0891 17.3416 16.6547 17.7326 16.4013L17.7526 16.3883C19.7696 15.023 21.0954 12.7136 21.0954 10.0946Z" fill="url(#paint0_linear_5984_51730)" />
                    <path d="M13.5034 15.3135C16.3444 15.3135 18.6474 13.0104 18.6474 10.1694C18.6474 7.32845 16.3444 5.02539 13.5034 5.02539C10.6624 5.02539 8.35938 7.32845 8.35938 10.1694C8.35938 13.0104 10.6624 15.3135 13.5034 15.3135Z" fill="url(#paint1_linear_5984_51730)" />
                    <path d="M20.6955 12.5354L15.9165 7.7564C15.8453 7.62505 15.7329 7.5332 15.5718 7.5332H11.5191C11.2095 7.5332 11.0781 7.87094 11.0781 8.1805C11.0781 8.46824 11.1821 8.72517 11.3702 8.81365L12.8136 10.2856V13.9406C12.8136 14.0885 12.9026 14.1997 13.0365 14.2748L17.107 18.3453V17.5559C17.107 17.0899 17.343 16.6556 17.7341 16.4021L17.7541 16.3891C19.1136 15.4689 20.1584 14.1193 20.6955 12.5354Z" fill="url(#paint2_linear_5984_51730)" />
                    <path d="M15.5249 7.49023H11.4722C11.1626 7.49023 11.0312 7.82797 11.0312 8.13753C11.0312 8.49403 11.1907 8.80359 11.4722 8.80359H12.7668V13.8976C12.7668 14.1978 13.1327 14.3479 13.4986 14.3479C13.8645 14.3479 14.2303 14.1978 14.2303 13.8976V8.80359H15.525C15.8064 8.80359 15.9659 8.49403 15.9659 8.13753C15.9658 7.82792 15.8344 7.49023 15.5249 7.49023Z" fill="url(#paint3_linear_5984_51730)" />
                    <path d="M23.8094 9.42578H22.1956C21.8115 9.42578 21.5 9.7372 21.5 10.1214C21.5 10.5055 21.8114 10.817 22.1956 10.817H23.8094C24.1935 10.817 24.505 10.5056 24.505 10.1214C24.505 9.7372 24.1936 9.42578 23.8094 9.42578Z" fill="url(#paint4_linear_5984_51730)" />
                    <path d="M5.505 10.1214C5.505 9.73724 5.19358 9.42578 4.80939 9.42578H3.19561C2.81142 9.42578 2.5 9.7372 2.5 10.1214C2.5 10.5055 2.81142 10.817 3.19561 10.817H4.80939C5.19354 10.817 5.505 10.5055 5.505 10.1214Z" fill="url(#paint5_linear_5984_51730)" />
                    <path d="M21.7422 13.985C21.4705 13.7133 21.0301 13.7133 20.7584 13.985C20.4868 14.2566 20.4868 14.6971 20.7584 14.9687L21.8995 16.1098C22.1712 16.3815 22.6116 16.3815 22.8833 16.1098C23.1549 15.8382 23.1549 15.3977 22.8833 15.1261L21.7422 13.985Z" fill="url(#paint6_linear_5984_51730)" />
                    <path d="M5.10153 4.13342C4.82989 3.86178 4.38944 3.86178 4.1178 4.13342C3.84615 4.40507 3.84615 4.84551 4.1178 5.11716L5.2589 6.25826C5.53055 6.52991 5.97099 6.52991 6.24264 6.25826C6.51428 5.98662 6.51428 5.54617 6.24264 5.27453L5.10153 4.13342Z" fill="url(#paint7_linear_5984_51730)" />
                    <path d="M6.24264 13.985C5.97099 13.7133 5.53055 13.7133 5.2589 13.985L4.1178 15.1261C3.84615 15.3977 3.84615 15.8382 4.1178 16.1098C4.38944 16.3815 4.82989 16.3815 5.10153 16.1098L6.24264 14.9687C6.51428 14.697 6.51428 14.2566 6.24264 13.985Z" fill="url(#paint8_linear_5984_51730)" />
                    <path d="M20.7584 6.25826C21.0301 6.52991 21.4705 6.52991 21.7422 6.25826L22.8833 5.11716C23.1549 4.84551 23.1549 4.40507 22.8833 4.13342C22.6116 3.86178 22.1712 3.86178 21.8995 4.13342L20.7584 5.27453C20.4868 5.54617 20.4868 5.98662 20.7584 6.25826Z" fill="url(#paint9_linear_5984_51730)" />
                    <path d="M17.1077 17.9497L14.4774 15.3194C14.2488 15.0502 13.908 14.8789 13.5271 14.8789C12.839 14.8789 12.2812 15.4367 12.2812 16.1248C12.2812 16.1696 12.2834 16.2141 12.2882 16.2576C12.3227 16.5842 12.484 16.8732 12.7217 17.0751L14.9278 19.2812H17.1077V17.9497Z" fill="url(#paint10_linear_5984_51730)" />
                    <path d="M13.4959 17.3454C14.184 17.3454 14.7419 16.7876 14.7419 16.0994C14.7419 15.4113 14.184 14.8535 13.4959 14.8535C12.8078 14.8535 12.25 15.4113 12.25 16.0994C12.25 16.7876 12.8078 17.3454 13.4959 17.3454Z" fill="url(#paint11_linear_5984_51730)" />
                    <path d="M6.42188 12.8516C6.98406 14.2927 7.97314 15.5202 9.23444 16.3778C9.24255 16.3833 9.24742 16.3924 9.24742 16.4022C9.6499 16.6534 9.8945 17.0943 9.8945 17.5687V19.2797H17.1039V17.5533C17.1039 17.0873 17.3399 16.653 17.731 16.3995L17.751 16.3865C19.0185 15.5286 20.0127 14.2977 20.5768 12.8516H6.42188V12.8516Z" fill="url(#paint12_linear_5984_51730)" />
                    <path d="M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z" fill="url(#paint13_linear_5984_51730)" />
                    <path d="M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z" fill="url(#paint14_linear_5984_51730)" />
                    <path d="M9.97656 21.957C10.606 23.4614 11.947 24.5002 13.4996 24.5002C15.0522 24.5002 16.3931 23.4614 17.0226 21.957H9.97656Z" fill="url(#paint15_linear_5984_51730)" />
                    <path d="M16.6766 20.4238H10.3136C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3417 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3417 20.4238 16.6766 20.4238Z" fill="url(#paint16_linear_5984_51730)" />
                    <path d="M16.6766 18.0156H10.3136C9.64852 18.0156 9.10938 18.5548 9.10938 19.2199C9.10938 19.885 9.64857 20.4241 10.3136 20.4241H16.6766C17.3417 20.4241 17.8809 19.885 17.8809 19.2199C17.8809 18.5548 17.3417 18.0156 16.6766 18.0156Z" fill="url(#paint17_linear_5984_51730)" />
                    <path d="M16.6766 20.4238L13.5082 20.3066L10.3136 20.4238C9.64852 20.4238 9.10938 20.963 9.10938 21.6281C9.10938 22.2932 9.64857 22.8324 10.3136 22.8324H16.6766C17.3418 22.8324 17.8809 22.2932 17.8809 21.6281C17.8809 20.963 17.3418 20.4238 16.6766 20.4238Z" fill="url(#paint18_linear_5984_51730)" />
                    <defs>
                        <linearGradient id="paint0_linear_5984_51730" x1="7.93971" y1="5.55907" x2="17.0821" y2="14.7015" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint1_linear_5984_51730" x1="11.5881" y1="8.25411" x2="19.3877" y2="16.0536" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint2_linear_5984_51730" x1="19.8051" y1="16.3438" x2="7.67629" y2="4.21497" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#D52C1C" stop-opacity="0" />
                            <stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
                            <stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
                            <stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
                            <stop offset="1" stop-color="#A42B31" />
                        </linearGradient>
                        <linearGradient id="paint3_linear_5984_51730" x1="11.5522" y1="8.09465" x2="16.2824" y2="12.8249" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#E38523" />
                            <stop offset="1" stop-color="#C4237C" />
                        </linearGradient>
                        <linearGradient id="paint4_linear_5984_51730" x1="20.5813" y1="9.21341" x2="25.2617" y2="10.9686" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint5_linear_5984_51730" x1="1.58127" y1="9.21341" x2="6.26166" y2="10.9686" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint6_linear_5984_51730" x1="19.4346" y1="14.1526" x2="24.0474" y2="15.8824" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint7_linear_5984_51730" x1="2.794" y1="4.30097" x2="7.40674" y2="6.03075" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint8_linear_5984_51730" x1="3.46243" y1="14.4032" x2="6.78304" y2="15.6485" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint9_linear_5984_51730" x1="20.1031" y1="4.55165" x2="23.4237" y2="5.79689" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#F7E07D" />
                            <stop offset="1" stop-color="#E69642" />
                        </linearGradient>
                        <linearGradient id="paint10_linear_5984_51730" x1="17.1961" y1="19.7937" x2="13.3824" y2="15.98" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#D52C1C" stop-opacity="0" />
                            <stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
                            <stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
                            <stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
                            <stop offset="1" stop-color="#A42B31" />
                        </linearGradient>
                        <linearGradient id="paint11_linear_5984_51730" x1="12.8755" y1="15.4789" x2="14.0165" y2="16.62" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#E38523" />
                            <stop offset="1" stop-color="#C4237C" />
                        </linearGradient>
                        <linearGradient id="paint12_linear_5984_51730" x1="13.4994" y1="14.7928" x2="13.4994" y2="18.3093" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#D52C1C" stop-opacity="0" />
                            <stop offset="0.28" stop-color="#D12C1E" stop-opacity="0.28" />
                            <stop offset="0.5735" stop-color="#C42C23" stop-opacity="0.574" />
                            <stop offset="0.8721" stop-color="#AF2B2C" stop-opacity="0.872" />
                            <stop offset="1" stop-color="#A42B31" />
                        </linearGradient>
                        <linearGradient id="paint13_linear_5984_51730" x1="13.4951" y1="18.721" x2="13.4951" y2="20.1877" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#EEF4FF" />
                            <stop offset="1" stop-color="#CFE7FD" />
                        </linearGradient>
                        <linearGradient id="paint14_linear_5984_51730" x1="10.5019" y1="23.2286" x2="15.9964" y2="23.2286" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5A5A5A" />
                            <stop offset="1" stop-color="#464646" />
                        </linearGradient>
                        <linearGradient id="paint15_linear_5984_51730" x1="13.4996" y1="24.1335" x2="13.4996" y2="23.2058" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#464646" stop-opacity="0" />
                            <stop offset="1" stop-color="#202020" />
                        </linearGradient>
                        <linearGradient id="paint16_linear_5984_51730" x1="13.4951" y1="20.7913" x2="13.4951" y2="22.519" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#EEF4FF" />
                            <stop offset="1" stop-color="#CFE7FD" />
                        </linearGradient>
                        <linearGradient id="paint17_linear_5984_51730" x1="13.4951" y1="19.2818" x2="13.4951" y2="20.7916" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#8AAADC" stop-opacity="0" />
                            <stop offset="1" stop-color="#8AAADC" />
                        </linearGradient>
                        <linearGradient id="paint18_linear_5984_51730" x1="13.4952" y1="21.7098" x2="13.4952" y2="22.7287" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#8AAADC" stop-opacity="0" />
                            <stop offset="1" stop-color="#8AAADC" />
                        </linearGradient>
                    </defs>
                </svg>
                    Recommendation:</>
                : <><svg className="f4 mr0-5rem mah2rem maw2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path className="fa-primary" d="M256 304c13.25 0 24-10.75 24-24v-128C280 138.8 269.3 128 256 128S232 138.8 232 152v128C232 293.3 242.8 304 256 304zM256 337.1c-17.36 0-31.44 14.08-31.44 31.44C224.6 385.9 238.6 400 256 400s31.44-14.08 31.44-31.44C287.4 351.2 273.4 337.1 256 337.1z" /><path className="fa-secondary" d="M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256s256-114.6 256-256S397.4 0 256 0zM232 152C232 138.8 242.8 128 256 128s24 10.75 24 24v128c0 13.25-10.75 24-24 24S232 293.3 232 280V152zM256 400c-17.36 0-31.44-14.08-31.44-31.44c0-17.36 14.07-31.44 31.44-31.44s31.44 14.08 31.44 31.44C287.4 385.9 273.4 400 256 400z" /></svg>
                    Risk:</>
            }
        </h5>
    };

    const sortQuestionsByQNo = (questions) => {
        if (questions.length > 0) {
            return questions.sort((a, b) => {
                const aParts = a['qNo'].match(/\d+/g).map(Number);
                const bParts = b['qNo'].match(/\d+/g).map(Number);
                for (let i = 0; i < Math.max(aParts.length, bParts.length); i++)
                    if ((aParts[i] || 0) !== (bParts[i] || 0)) return (aParts[i] || 0) - (bParts[i] || 0);
                return 0;
            });
        }
    };

    const onAccurateFileName = () => {
        dispatch(updateFileAllocation({
            autoFillContext: {
                enabled: false,
                companyId,
                moduleType: tab,
                moduleId: activeModule?._id,
                sectionCode: null,
                scope: 'module',
                scopeName: '',
            },
            tab,
        }));
        dispatch(toggleModal({ open: 'autoFillStepper', autoFillStepperPhase: 'select', autoFillStatusBarPhase: 'select', autoFillWithFilling: false, autoFillUploadMode: 'files' }));
    };
    const onAccurateFolderName = () => {
        dispatch(updateFileAllocation({
            autoFillContext: {
                enabled: false,
                companyId,
                moduleType: tab,
                moduleId: activeModule?._id,
                sectionCode: null,
                scope: 'module',
                scopeName: '',
            },
            tab,
        }));
        dispatch(toggleModal({ open: 'autoFillStepper', autoFillStepperPhase: 'select', autoFillStatusBarPhase: 'select', autoFillWithFilling: false, autoFillUploadMode: 'folders' }));
    };
    const handleDisconnectDataRoom = async (dataroomType) => dispatch(toggleModal({ open: 'disconnectDataRoom', modalHistory: dataroomType }));

    const handleDateChange = (e, question, qNo) => {
        setDateValue((prev) => (prev, { [question._id]: e.target.value }));
        debouncedSaveAnswer(e, question, qNo);
    };

    const subFolderModules = ["repository"];
    const getSectionHTML = (module, currentSection) => {
        return <SectionRenderer
            module={module}
            currentSection={currentSection}
            section={section}
            refresh={refresh}
            loading={loading}
            isSaving={isSaving}
            questionsAndAnswersToSave={questionsAndAnswersToSave}
            attachment={attachment}
            visibleSection={visibleSection}
            isFAMenuVisible={isFAMenuVisible}
            deleteFile={deleteFile}
            dateValue={dateValue}
            additionalSections={additionalSections}
            isSectionNameDuplicate={isSectionNameDuplicate}
            reportGenerateLoading={reportGenerateLoading}
            hasAgreedAiReportDisclaimer={hasAgreedAiReportDisclaimer}
            saveAnswer={saveAnswer}
            radioButtonChanged={radioButtonChanged}
            handleFileChange={handleFileChange}
            confirmDeleteFile={confirmDeleteFile}
            syncDrive={syncDrive}
            syncDropbox={syncDropbox}
            syncSharePoint={syncSharePoint}
            generateInsuranceAiReport={generateInsuranceAiReport}
            handleSectionReportLinkClick={handleSectionReportLinkClick}
            setSection={setSection}
            setRefresh={setRefresh}
            setDeleteFile={setDeleteFile}
            setDeleteFileQuestionId={setDeleteFileQuestionId}
            handleSectionLogs={handleSectionLogs}
            setLogModule={setLogModule}
            onClickFileManager={onClickFileManager}
            answerSaved={answerSaved}
            getViewableURL={getViewableURL}
            getFilesFromQuestions={getFilesFromQuestions}
            showRiskRecommendation={showRiskRecommendation}
            sortQuestionsByQNo={sortQuestionsByQNo}
            getReportGenerationKey={getReportGenerationKey}
            hasSectionReport={hasSectionReport}
            getSectionReport={getSectionReport}
            getSectionTabName={getSectionTabName}
            getCompletenessAndRiskHTML={getCompletenessAndRiskHTML}
            user={user}
            modal={modal}
            company={company}
            tab={tab}
            permissionLevel={permissionLevel}
            advisors={advisors}
            companyId={companyId}
            openKPI={openKPI}
            isTwoMinuteTesHomePage={isTwoMinuteTesHomePage}
            sortSections={sortSections}
            aiEnhanced={aiEnhanced}
            setAiEnchaned={setAiEnchaned}
            onDragOver={onDragOver}
            onDrop={onDrop}
            handleDateChange={handleDateChange}
            dispatch={dispatch}
            toggleModal={toggleModal}
            sectionRefs={sectionRefs}
            moduleId={activeModule?._id || null}
            reloadModule={reloadModule}
            patchAnswerInModule={patchAnswerInModule}
        />;
    };

    return (
        <>
            <div className="td250 container bg1 py1rem w100 df">
                <div className="w80 mr1rem df fdc gg1rem">
                    {/* Top Section */}
                    {user?.role.toLowerCase() === "guest" ? <HeadingSubheadingContent
                        wrapperClass="tac"
                        heading={activeModule?.heading}
                        subheading={activeModule?.subheading}
                        paragraph={isTwoMinuteTesHomePage ? <>
                            Register at the end of test to access more features <span className="fs11px">(No credit card required)</span>
                            <br></br>
                            <LockOutlined className="c3" />
                        </> : <></>}
                    /> : null
                    }
                    {isManualAdd && <p class='c15 fs1-5rem tac fw500 pb1rem'>Key Applicant Information</p>}
                    {tab !== 'investor-lead' &&
                        <div className="df jcsb btn-dataroom-saf pr">
                            {/* LEFT: legend + Connect/DataRoom + Analyse All */}
                            <div className="df fdc">
                                {!isManualAdd && (
                                    <ul className="list-file-manager">
                                        <li className="bg1 fw400 c2 upload-file">Uploaded Directly</li>
                                        <li className="bg1 fw400 c2 prepopulated-file">Companies House</li>
                                        <li className="bg1 fw400 c2 filing-assistant-file">AI Filing Assistant</li>
                                        <li className="bg1 fw400 c2 ai-report-file">AI Report</li>
                                        <li className="bg1 fw400 c2 sharepoint-file">Sharepoint</li>
                                        <li className="bg1 fw400 c2 dropbox-file">Dropbox</li>
                                        <li className="bg1 fw400 c2 gdrive-file">Drive</li>
                                    </ul>
                                )}
                                {tab?.includes('repository') && (
                                    <DataRoomButtons
                                        company={company}
                                        user={user}
                                        tab={tab}
                                        syncing={syncing}
                                        syncApiBase={syncApiBase}
                                        onConnectDataRoom={(apiBase) => {
                                            sessionStorage.setItem("dataroomConnectApiBase", apiBase);
                                            dispatch(toggleModal({ open: "connectDataroom" }));
                                        }}
                                        syncDrive={syncDrive}
                                        syncDropbox={syncDropbox}
                                        reverseSyncDropbox={reverseSyncDropbox}
                                        syncSharePoint={syncSharePoint}
                                        reSyncSharePoint={reSyncSharePoint}
                                        handleDisconnectDataRoom={handleDisconnectDataRoom}
                                        localModule={localModule}
                                        isDataRepository={isDataRepository}
                                        isTwoMinuteTesHomePage={isTwoMinuteTesHomePage}
                                    />
                                )}
                            </div>
                            {/* RIGHT: Filing Assistant */}
                            <div className="df aic">
                                {isTwoMinuteTesHomePage && (
                                    <button data-tooltip='Filling Assistant feature is disabled. You must register to access it.' className='da-cursor btn-filing-assistant bg3 op50 c1 td250 br50px px1rem py0-75rem fw600 cp bsbb tac df jcc aic fs0-75rem pr' disabled>
                                        <img className="pa r0" style={{ top: "-15px" }} src={require("../../../../../../images/fillingassistanticons.png")} alt="fillingIcons" />
                                        <LockOutlined style={{ color: "#fff", marginRight: "8px", fontSize: '12px' }} />
                                        Filing Assistant
                                    </button>
                                )}
                                {tab?.includes('repository') && !isTwoMinuteTesHomePage && <>
                                    <HeaderActions
                                        tab={tab}
                                        company={company}
                                        localModule={localModule}
                                        isDataRepository={isDataRepository}
                                        onAccurateFileName={onAccurateFileName}
                                        onAccurateFolderName={onAccurateFolderName}
                                        onClickFileReportHistory={onClickFileReportHistory}
                                        onClickViewUnallocatedFiles={onClickViewUnallocatedFiles}
                                        checkDuplicatedFiles={checkDuplicatedFiles}
                                        onClickDeduperReportHistory={onClickDeduperReportHistory}
                                        onAutoFill={activeModule?._id ? () => {
                                            dispatch(updateFileAllocation({
                                                autoFillContext: { enabled: true, companyId, moduleType: tab, moduleId: activeModule._id, scope: 'module', scopeName: activeModule.heading || tab },
                                                tab,
                                            }));
                                            dispatch(toggleModal({ open: 'tempAutoFillStepper', autoFillStepperPhase: 'select', autoFillStatusBarPhase: 'select', autoFillWithFilling: true, autoFillUploadMode: 'files' }));
                                        } : null}
                                    />
                                </>}
                            </div>
                        </div>
                    }
                    {tab !== 'investor-lead' && isDataRepository && ((!company?.isParent && company['owners'][0] === user._id) || (company?.isParent && company['owners'][0] === user._id) || ((company['servicedBy']?.['_id'] || company?.['servicedBy']) === user._id)) && <>
                        <div className="dg gtcr2-md gg0-5rem">
                            {company['lastSyncBy'] && localModule?.uploadFiles &&
                                <div className="df aic fs14px c15">
                                    {company['syncRequired'] && <span className="c4">* Sync is Required -  </span>}
                                    Last synced by - {company?.['lastSyncBy']?.['profile'] && <img className={`ass mx0-5rem br100 w2rem h2rem`} src={company?.['lastSyncBy']?.['profile']} />} {company?.['lastSyncBy']?.['firstName']},
                                    {moment(company['lastSyned']).format('lll')}
                                </div>
                            }
                        </div>
                    </>}

                    {/* QuesAns Section */}
                    {activeModuleLoading
                        ? <div className="df jcc aic p2rem c15 fs1rem">Loading module...</div>
                        : localModule && getSectionHTML(localModule)
                    }

                    {/* Bottom Section */}
                    {(isManualAdd && tab == 'investor-lead') &&
                        <div class='df jcc mt1rem'>
                            <button onClick={() => localModule?.['stats']?.['completionPercent'] && dispatch(toggleModal({ open: 'addingApplicantManual' }))} data-tooltip={localModule?.['stats']?.['completionPercent'] < 99 ? 'Please complete the questionnaire' : ''}
                                disabled={localModule?.['stats']?.['completionPercent'] < 99} className={`c1 br20px px4rem py0-5rem mb1rem fw500 tac ${(localModule?.['stats']?.['completionPercent'] < 99) ? 'cna bg16' : 'cp bg4'}`} >
                                Next
                            </button>
                        </div>
                    }
                    {tab == 'repository' &&
                        <div className="py2rem df jcc">
                            <div>
                                <button className={`${(localModule?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`} onClick={(e) => toggleReport(e)}>
                                    {tab.endsWith("-report") ? "Close" : "View"}{' Report'}
                                </button>
                            </div>
                        </div>
                    }
                    {tab == 'business-audit' &&
                        <div className="py2rem df jcc">
                            <button onClick={() => enableAIEnhancedReporting()} className={`${(localModule?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} h100 mt0-5rem mxa shadow bg3 bg4-hover c1 td250 br5px px1rem fs0-75rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`}>
                                <svg className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="fa-primary" d="M339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /><path className="fa-secondary" d="M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96C448 60.65 419.3 32 384 32zM339.8 211.8l-128 128C206.3 345.3 199.2 348 192 348s-14.34-2.719-19.81-8.188l-64-64c-10.91-10.94-10.91-28.69 0-39.63c10.94-10.94 28.69-10.94 39.63 0L192 280.4l108.2-108.2c10.94-10.94 28.69-10.94 39.63 0C350.7 183.1 350.7 200.9 339.8 211.8z" /></svg>
                                AI Enhanced Report
                            </button>
                        </div>
                    }
                    {(tab == 'warranty-disclosure' || tab == 'software-development') &&
                        <div className="py3rem df jcc">
                            <button className={`${(localModule?.['stats']?.['completionPercent'] == 0) && 'op20 pen '} shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttc bsbb tac df jcc aic`} onClick={() => toggleReport()}>
                                {tab.endsWith("-report") ? "Close" : "View"}
                                {tab == 'warranty-disclosure'
                                    ? ' Disclosure Schedule'
                                    : ' Report'
                                }
                            </button>
                        </div>
                    }
                </div>

                {localModule && <SidebarIndex isManualAdd={isManualAdd} setIsWorkflowReport={setIsWorkflowReport} visibleSection={visibleSection} setTab={setTab} profileClass={profileClass} advisors={advisors} permissionLevel={permissionLevel} company={company} setCompany={setCompany} tab={tab} sanitiseTab={sanitiseTab} toggleReport={toggleReport} openKPI={openKPI} calculateStats={calculateStats}
                    calculateSubFolderStats={calculateSubFolderStats} getCompletenessAndRiskHTML={getCompletenessAndRiskHTML} setSection={setSection} getViewableURL={getViewableURL} twoMinuteTestAIReport={twoMinuteTestAIReport} isTwoMinuteTesHomePage={isTwoMinuteTesHomePage} getFitInvestorFirms={getFitInvestorFirms} setOpenTabs={setOpenTabs} openTabs={openTabs} sortSections={sortSections}
                    handleSuperflowNext={handleSuperflowNext} setCompanyDashboardTab={setCompanyDashboardTab} setTabName={setTabName} closeTab={closeTab} isBackFitReport={isBackFitReport} setIsBackFitReport={setIsBackFitReport} isLoader={isLoader} setIsLoader={setIsLoader} isExternalPage={false} tempModule={localModule} />
                }
            </div>

            {/* Loading report generate */}

            {
                reportGenerateLoading && (
                    <div className="df jcc aic pf l0 b0 bg1 p2rem br20px shadow" style={{ maxWidth: '450px', margin: '0 auto 0 90px', zIndex: '1000' }}>
                        <div className="loading-report-generate">
                            <div className="df aic jcc ">
                                <img width={50} className="mr1-5rem" src={require('../../../../../../images/reportLoader/left.png')} alt="loading-report-left" />
                                <img width={50} className="mr1rem infinite-rotate" src={require('../../../../../../images/reportLoader/center.png')} alt="loading-report-center" />
                                <img width={50} src={require('../../../../../../images/reportLoader/right.png')} alt="loading-report-right" />
                            </div>

                            {/* <p className="fs1rem fw500 c15 tac my1rem fsi">100%</p> */}
                            <p className="fs14px fw400 c37 tac mt1rem">Report being generated - please continue other tasks - we will let you know when report complete</p>
                        </div>
                    </div>
                )
            }


            {/* Modals */}
            <ModalsSection
                deleteFile={deleteFile}
                deleteUnallocatedFile={deleteUnallocatedFile}
                deleteFileLoading={deleteFileLoading}
                logModule={logModule}
                isSaving={isSaving}
                attachment={attachment}
                additionalSections={additionalSections}
                isSectionNameDuplicate={isSectionNameDuplicate}
                isCustomSectionEnabled={activeModule?.isCustomSection === true}
                newUpgradeSync={newUpgradeSync}
                confirmDeleteFile={confirmDeleteFile}
                confirmDeleteUnallocatedFile={confirmDeleteUnallocatedFile}
                moveUnallocatedFile={moveUnallocatedFile}
                moveDeduperFile={moveDeduperFile}
                onClickDeduperAuditLog={onClickDeduperAuditLog}
                onClickUnallocatedBinAuditLog={onClickUnallocatedBinAuditLog}
                onClickFileReportHistory={onClickFileReportHistory}
                showDeduperReport={showDeduperReport}
                onClickDeduperReportHistory={onClickDeduperReportHistory}
                onSaveAdditionalSections={onSaveAdditionalSections}
                editSectionName={editSectionName}
                onEdit={onEdit}
                onDelete={onDelete}
                handleToggleSuccessAiReportGeneratedModal={handleToggleSuccessAiReportGeneratedModal}
                handleAiReportDisclaimerClose={handleAiReportDisclaimerClose}
                getDeduperReportLogsHTML={getDeduperReportLogsHTML}
                getFileReportLogsHTML={getFileReportLogsHTML}
                getUnallocatedBinLogsHTML={getUnallocatedBinLogsHTML}
                getViewableURL={getViewableURL}
                handleEditDispatch={handleEditDispatch}
                handleFileChange={handleFileChange}
                setDeleteFile={setDeleteFile}
                setDeleteFileQuestionId={setDeleteFileQuestionId}
                setDeleteUnallocatedFile={setDeleteUnallocatedFile}
                setLoading={setLoading}
                setRefresh={setRefresh}
                setSection={setSection}
                syncDrive={syncDrive}
                syncDropbox={syncDropbox}
                syncSharePoint={syncSharePoint}
                openWindow={openWindow}
                toggleReport={toggleReport}
                onMoveFile={handleTempMoveFile}
                modal={modal}
                user={user}
                logList={logList}
                targetSection={targetSection}
                processing={processing}
                unallocatedFiles={unallocatedFiles}
                dupCheck={dupCheck}
                company={company}
                companyId={companyId}
                tab={tab}
                permissionLevel={permissionLevel}
                advisors={advisors}
                profileClass={profileClass}
                loading={loading}
                section={section}
                reloadModule={reloadModule}
                reportHistories={reportHistories}
                setReportHistories={setReportHistories}
                setFileReport={setFileReport}
                setCloneImportResult={setCloneImportResult}
                setCurrentScore={setCurrentScore}
                fileImportRef={fileImportRef}
                onRollbackComplete={() => reloadModule && reloadModule(tab)}
            />

        </>
    );
}